import styled from "styled-components";

export const ProfileMessagesDividerDefaultBox = styled.div`
    flex: 1;
    max-width: 1px;
    background: transparent;
`;
